import React, {useState, useEffect} from 'react'
import { Wrapper } from './style';

const VideoPlayer = ({ src, customWidth, customScreenWidth, center, poster }) => {
const [width, setWidth] = useState();

useEffect(() => {
    const handleWindowResize = () => {
        if (window.innerWidth > customScreenWidth) {
            setWidth(customWidth);
        }
        else {
            if (window.innerWidth > 600) {
                setWidth(window.innerWidth - 50);
            }
            else {
                setWidth(window.innerWidth);
            }
        }
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });

  useEffect(() => {
    if (window.innerWidth > customScreenWidth) {
        setWidth(customWidth);
    }
    else {
        if (window.innerWidth > 600) {
            setWidth(window.innerWidth - 50);
        }
        else {
            setWidth(window.innerWidth);
        }
    }
  }, [])
  

    return (
            <Wrapper center={center}>
                <div 
                    className='video-player'
                    style={{ width: width*0.9 + "px", height: width/1.78*0.9 + "px"}}
                >
                    <div className='video'>
                        <video 
                            preload="auto" 
                            controls
                            width={width*0.9 + "px"}
                            height={width/1.78*0.9 + "px"}
                            src={src}
                            poster={poster}
                        />
                    </div>
                </div>
            </Wrapper>
    )
}

export default VideoPlayer;